import css_jib8de2xgci from './css/AdPlayer.css';
/** @namespace adData.adError */
/** @namespace adError.getErrorCode */
/** @namespace adError.getInnerError */
/** @namespace adError.getMessage */
/** @namespace adsManager.getCuePoints */
/** @namespace adsManager.discardAdBreak */
/** @namespace adsManager.getRemainingTime */
/** @namespace adsManager.getVolume */
/** @namespace adsManager.resize */
/** @namespace adsManager.setVolume */
/** @namespace adsRequest.setAdWillAutoPlay */
/** @namespace config */
/** @namespace event.getAd.getAdPodInfo.getPodIndex */
/** @namespace event.getAd.getDuration */
/** @namespace google.ima.AdDisplayContainer*/
/** @namespace google.ima.AdError.ErrorCode.AUTOPLAY_DISALLOWED */
/** @namespace google.ima.AdError.ErrorCode.VIDEO_PLAY_ERROR */
/** @namespace google.ima.AdErrorEvent.Type.AD_ERROR */
/** @namespace google.ima.AdEvent.getAdData */
/** @namespace google.ima.AdEvent.getAdsManager */
/** @namespace google.ima.AdEvent.Type.AD_BREAK_READY */
/** @namespace google.ima.AdEvent.Type.AD_PROGRESS */
/** @namespace google.ima.AdEvent.Type.ALL_ADS_COMPLETED */
/** @namespace google.ima.AdEvent.Type.COMPLETE */
/** @namespace google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED */
/** @namespace google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED */
/** @namespace google.ima.AdEvent.Type.IMPRESSION */
/** @namespace google.ima.AdEvent.Type.LOG */
/** @namespace google.ima.AdEvent.Type.PAUSED */
/** @namespace google.ima.AdEvent.Type.RESUMED */
/** @namespace google.ima.AdEvent.Type.STARTED */
/** @namespace google.ima.AdEvent.Type.VOLUME_CHANGED */
/** @namespace google.ima.AdEvent.Type.VOLUME_MUTED */
/** @namespace google.ima.AdsLoader.requestAds */
/** @namespace google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED */
/** @namespace google.ima.AdsRenderingSettings */
/** @namespace google.ima.AdsRequest */
/** @namespace google.ima.ImaSdkSettings.VpaidMode.INSECURE */
/** @namespace google.ima.settings.setAutoPlayAdBreaks */
/** @namespace google.ima.settings.setDisableCustomPlaybackForIOS10Plus */
/** @namespace google.ima.settings.setVpaidMode */
/** @namespace google.ima.UiElements.AD_ATTRIBUTION */
/** @namespace google.ima.UiElements.COUNTDOWN */
/** @namespace google.ima.ViewMode.NORMAL */
/** @namespace pbjs.addAdUnits */
/** @namespace pbjs.removeAdUnit */
/** @namespace pbjs.requestBids */
/** @namespace pbjs.setConfig */

import GetPrivateData from '../Classes/GetPrivateData.js';
import Div from './Div.js';
import AdUI from './AdUI.js';
import randomBase64 from '../Functions/randomBase64.js';
import objectToUrlQuery from '../Functions/objectToUrlQuery.js';
import getShim from '../Functions/getShim.js';

const css = css_jib8de2xgci;

export default class AdPlayer extends Div
{
	constructor(parentElement, contentPlayer, companionAd)
	{
		super(parentElement);

		this.adUI = new AdUI(this,contentPlayer);

		const privateData = getPrivateData.for(this);

		privateData.contentPlayer = contentPlayer;
		privateData.companionAd = companionAd;
		privateData.videoElements = new Set;

		const dispatchEvent = this.dispatchEvent.bind(this);

		this.element.addEventListener
		(
			'mouseenter',
			() => this.element.classList.add('hover')
		);

		this.element.addEventListener
		(
			'mouseleave',
			() => this.element.classList.remove('hover')
		);

		function onVolumeChange()
		{
			const videoElement = this;
			const enforcedVolume = privateData.adVolume.toFixed(3);
			const actualVolume = (videoElement.muted ? 0 : videoElement.volume).toFixed(3);
			if(enforcedVolume !== actualVolume)
			{
				if(enforcedVolume)
				{
					videoElement.volume = privateData.adVolume;
				}
				else
				{
					videoElement.muted = true;
				}
			}
		}

		config.videoFinder.addEventListener
		(
			'inserted',
			videoElement =>
			{
				if(this.element.contains(videoElement))
				{
					videoElement.addEventListener('volumechange', onVolumeChange);
					onVolumeChange.call(videoElement);
					privateData.videoElements.add(videoElement);
				}
			}
		);

		config.videoFinder.addEventListener
		(
			'removed',
			videoElement =>
			{
				if(privateData.videoElements.has(videoElement))
				{
					privateData.videoElements.delete(videoElement);
					videoElement.removeEventListener('volumechange', onVolumeChange);
				}
			}
		);

		this.shimmed = config.scripts.ima.then
		(
			() =>
			{
				google.ima.settings.setDisableCustomPlaybackForIOS10Plus(true);
				if(config.feed.insecureImaFrame)
				{
					google.ima.settings.setVpaidMode(google.ima.ImaSdkSettings.VpaidMode.INSECURE);
				}
				this.adDisplayContainer = new google.ima.AdDisplayContainer(this.element);
				this.adDisplayContainer.initialize();

				const adPlayerElement = this.element;
				config.gestures.subscribe
				(
					function onGesture()
					{
						config.gestures.unsubscribe(onGesture);
						Array.from(adPlayerElement.querySelectorAll('video')).forEach
						(
							videoElement =>
							{
								if(videoElement.paused)
								{
									videoElement.muted = !videoElement.muted;
									videoElement.muted = !videoElement.muted;
								}
								else
								{
									// noinspection JSIgnoredPromiseFromCall todo
									videoElement.play();
								}
							}
						);
						dispatchEvent('gestured');
					}
				);
			}
		)
		/*
		.then
		(
			() =>
			{
				if(config.feed.insecureImaFrame)
				{
					return 'insecure';
				}
				return new Promise
				(
					resolve =>
					{
						const shimLoader = new google.ima.AdsLoader(this.adDisplayContainer);
						shimLoader.addEventListener
						(
							google.ima.AdErrorEvent.Type.AD_ERROR,
							error =>
							{
								shimLoader.destroy();
								resolve('failure');
							}
						);
						setTimeout
						(
							() =>
							{
								resolve('timeout');
							},
							2000
						);

						shimLoader.addEventListener
						(
							google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED,
							adsManagerLoadedEvent =>
							{
								const adsManager = adsManagerLoadedEvent.getAdsManager(privateData.contentPlayer.proxy);
								adsManager.addEventListener
								(
									google.ima.AdEvent.Type.ALL_ADS_COMPLETED,
									() =>
									{
										shimLoader.contentComplete();
										adsManager.stop();
										adsManager.destroy();
										shimLoader.destroy();
										resolve('success');
									}
								);
								adsManager.init(640, 360, google.ima.ViewMode.NORMAL);
								adsManager.start(640, 360, google.ima.ViewMode.NORMAL);
							}
						);

						const shimRequest = new google.ima.AdsRequest();
						shimRequest.adsResponse = getShim();
						shimLoader.requestAds(shimRequest);
					}
				);
			}
		)
		*/
		.finally
		(
			() =>
			{
				this.dispatchEvent('ready');
			}
		);

		this.element.addEventListener
		(
			'active',() =>
			{
				this.element.classList.add('active');
			}
		);

		this.element.addEventListener
		(
			'play',() =>
			{
				this.element.classList.add('playing');
			}
		);
		this.element.addEventListener
		(
			'pause',() =>
			{
				this.element.classList.remove('playing');
			}
		);
		this.element.addEventListener
		(
			'inactive',() =>
			{
				this.element.classList.remove('active');
			}
		);
		this.element.addEventListener
		(
			'timeupdate',
			event =>
			{
				const detail = event.detail;
				this.adUI.progressBar.progressValue.value = detail.currentTime / detail.duration * 100;
				this.adUI.remaining.value = detail.duration - detail.currentTime;
			}
		);

		const contentVolumeChanged = () =>
		{
			privateData.adVolume = contentPlayer.muted() ? 0 : contentPlayer.volume();
			privateData.videoElements.forEach( videoElement => onVolumeChange.call(videoElement) );
			if(this.adsManager)
			{
				this.adsManager.setVolume(privateData.adVolume);
			}
		};
		contentPlayer.element.addEventListener('volumechange', contentVolumeChanged);
		contentVolumeChanged();
	}

	resize()
	{
		this.adsManager && this.adsManager.resize
		(
			this.element.clientWidth,
			this.element.clientHeight,
			google.ima.ViewMode.NORMAL
		);
	}

	get cssText()
	{
		return css;
	}

	volume(...args)
	{
		const contentPlayer = getPrivateData.for(this).contentPlayer;
		return contentPlayer.volume(...args);
	}

	muted(...args)
	{
		const contentPlayer = getPrivateData.for(this).contentPlayer;
		return contentPlayer.muted(...args);
	}

	load(getAdTag)
	{
		const privateData = getPrivateData.for(this);

		const loadResult = this.shimmed
		.then
		(
			shimStatus =>
			{
				this.element.classList.remove('active');
				this.element.classList.remove('playing');

				this.adsRequest = null;

				if(this.adsManager)
				{
					this.adsManager.stop();
					this.adsManager.destroy();
					this.adsManager = null;
				}
				if(this.adsLoader)
				{
					this.adsLoader.destroy();
					this.adsLoader = null;
				}

				privateData.hasStarted = false;
				privateData.active = false;
				privateData.playing = false;

				this.adsLoader = new google.ima.AdsLoader(this.adDisplayContainer);

				this.adsRequest = new google.ima.AdsRequest();
				this.adsRequest.linearAdSlotHeight = this.element.clientHeight;
				this.adsRequest.linearAdSlotWidth = this.element.clientWidth;
				this.adsRequest.nonLinearAdSlotHeight = this.element.clientHeight;
				this.adsRequest.nonLinearAdSlotWidth = this.element.clientWidth;
				this.adsRequest.forceNonLinearFullSlot = true;
				this.adsRequest.setAdWillAutoPlay(true);
				// this.adsRequest.setAdWillPlayMuted(true);
				// this.adsRequest.setContinuousPlayback(true);

				const adTag = getAdTag();

				if(config.feed.prebid)
				{
					// noinspection JSUnresolvedFunction
					const custom = Object.fromEntries
					(
						Object
						.entries(config.player.currentItem)
						.filter
						(
							v => v[0].slice(0,5).toLowerCase() === 'level'
						)
					);
					custom.play_code = config.ac_id.valueOf();

					const slot = config.player.layoutGrid.mediaGroupContainer.element;

					const video =
					{
						context: 'instream',
						mimes:
						[
							"video/mp4",
							"application/javascript",
							"video/webm",
							"video/ogg",
						],
						minduration: 5,
						maxduration: 30,
						protocols:
						[
							2,	// VAST 2.0
							3,	// VAST 3.0
							5,	// VAST 2.0 Wrapper
							6,	// Vast 3.0 Wrapper
							7,	// Vast 4.0
							8,	// VAST 4.0 Wrapper
						],
						w: slot.clientWidth,
						h: slot.clientHeight,
						placement: 1, // in-stream
						linearity: 1, // Linear / In-Stream
						api:
						// https://developers.google.com/interactive-media-ads/docs/sdks/html5/compatibility
						[
							2,	// VPAID 1.0
						],
					};

					video.sizes = [[video.w,video.h]];
					video.playerSize = video.sizes;

					// all bidders[] entries are forced lower case
					// noinspection SpellCheckingInspection
					const bidders =
					{
						spotx:
						{
							bidder:'spotx',
							params:
							{
								channel_id: ['229991','211441'][config.ac_id.pageHidden*1],
								ad_unit: 'instream',
								custom: custom,
							},
						},
						openx:
						{
							bidder: 'openx',
							params:
							{
								unit: ['540931806','540931802'][config.ac_id.pageHidden*1],
								delDomain: 'sendtonews-d.openx.net',
							},
						},
						ix:
						{
							bidder: 'ix',
							params:
							{
								siteId: ['438214','420876'][config.ac_id.pageHidden*1],
								custom: custom,
								size: [video.w,video.h],
								video: video
							},
						},
						onevideo:
						{
							bidder: 'oneVideo',
							params:
							{
								pubId: 'SendtonewsDirect',
								video: Object.assign
								(
									{
										playerWidth: video.w,
										playerHeight: video.h,
									},
									video
								),
							},
						},
						rubicon:
						{
							bidder: 'rubicon',
							params:
							{
								accountId: '18782',
								siteId: ['301654','301110'][config.isMobile*1],
								zoneId: ['1516070','1516068','1516074','1516072'][config.isMobile*2+config.ac_id.pageHidden*1],
								position: ['atf','btf'][config.ac_id.pageHidden*1],
								video:
								{
									language: 'en',
								},
							},
						},
					};

					const prebidAdUnit =
					{
						code: `${(new Date).getTime().toString(36)}.${randomBase64(6)}`,
						mediaTypes:
						{
							video,
						},
						bids:[],
					};

					// whitelisted
					['spotx','openx','ix','rubicon','oneVideo']
					// and configurable
					.concat(config.feed.prebidEnableBidders)
					.forEach
					(
						bidder =>
						{
							if(typeof bidder !== 'string')
							{
								return;
							}
							bidder = bidder.toLowerCase();
							if (bidders[bidder])
							{
								prebidAdUnit.bids.push(bidders[bidder]);
								delete bidders[bidder];
							}
						}
					);

					const prebidResult = config.scripts.prebid.then
					(
						() => new Promise
						(
							(resolve,reject) =>
							{
								setTimeout(reject,5000,'Prebid timeout');

								pbjs.setConfig
								(
									{
										cache:
										{
											url: 'https://prebid.adnxs.com/pbc/v1/cache'
										},
										userSync:
										{
											iframeEnabled: true,
											filterSettings:
											{
												iframe:
												{
													bidders: ['openx','rubicon'],
													filter: 'include'
												}
											}
										},
										// schain:
										// {
										// 	validation: "strict",
										// 	config:
										// 	{
										// 		ver:"1.0",
										// 		complete: 1,
										// 		nodes:
										// 		[
										// 			{
										// 				asi:"sendtonews.com",
										// 				sid: config.feed.sellerJsonId,
										// 				hp:1
										// 			}
										// 		]
										// 	}
										// },
									}
								);

								pbjs.addAdUnits( prebidAdUnit );
								pbjs.requestBids
								(
									{
										bidsBackHandler: bids =>
										{
											if(config.debug)
											{
												console.warn({bids});
											}

											if(!bids[prebidAdUnit.code])
											{
												reject('No Bids');
												return;
											}

											const winningBidCpm = Math.max.apply(null,bids[prebidAdUnit.code].bids.map(v=> v['cpm']));
											const winningBids = bids[prebidAdUnit.code].bids.filter( v => v['cpm'] === winningBidCpm );
											const winningBid = winningBids[Math.random() * winningBids.length | 0];
											const {bidder: hb_bidder, cpm: hb_bid, videoCacheKey: hb_uuid} = winningBid;

											resolve({hb_bidder,hb_bid,hb_uuid});
										}
									}
								);
							}
						)
					)
					.then
					(
						prebidParams =>
						{
							Object.assign(adTag[1].cust_params,prebidParams);
							return adTag;
						},
						reason =>
						{
							return adTag;
						}
					);

					prebidResult.then
					(
						() => pbjs.removeAdUnit()
					);

					return prebidResult;
				}
				else
				{
					return adTag;
				}
			}
		)
		.then
		(
			adTag =>
			adTag[0]+objectToUrlQuery(adTag[1])
		)
		.then
		(
			adTag => new Promise
			(
				(resolve,reject) =>
				{
					this.adsLoader.addEventListener
					(
						google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED,
						event =>
						{
							const adsRenderingSettings = new google.ima.AdsRenderingSettings;
							adsRenderingSettings.enablePreloading = true;
							adsRenderingSettings.uiElements = google.ima.UiElements.AD_ATTRIBUTION + google.ima.UiElements.COUNTDOWN;
							this.adsManager = event.getAdsManager(privateData.contentPlayer.proxy,adsRenderingSettings);
							this.adsManager.setVolume(privateData.adVolume);
							privateData.adCuePoints = this.adsManager.getCuePoints();

							// Object.keys(google.ima.AdEvent.Type)
							// .filter(key => !(['AD_PROGRESS'].indexOf(key)+1) )
							// .forEach
							// (
							// 	key =>
							// 	{
							// 		this.adsManager.addEventListener
							// 		(
							// 			google.ima.AdEvent.Type[key],
							// 			e => console.log('ima Event - ',e)
							// 		);
							// 	}
							// );

							resolve(this.adsManager);
						}
					);

					this.adsLoader.addEventListener
					(
						google.ima.AdErrorEvent.Type.AD_ERROR,
						event =>
						{
							reject(event.getError());
						}
					);

					google.ima.settings.setAutoPlayAdBreaks(false);
					this.adsRequest.adTagUrl = adTag;
					this.adsLoader.requestAds(this.adsRequest)
				}
			)
		)
		.then
		(
			adsManager =>
			{
				this.dispatchEvent('load');

				let completeTimeout = null;

				adsManager.addEventListener
				(
					google.ima.AdEvent.Type.AD_PROGRESS,
					event =>
					{
						const adData = event.getAdData();
						if(!adData.hasOwnProperty('currentTime'))
						{
							adData.currentTime = adData.duration - event.target.getRemainingTime();
						}
						privateData.adCurrentTime = adData.currentTime;
						this.dispatchEvent('timeupdate',{detail: adData});
					}
				);

				adsManager.addEventListener
				(
					google.ima.AdEvent.Type.ALL_ADS_COMPLETED,
					() => this.dispatchEvent('complete')
				);

				adsManager.addEventListener
				(
					google.ima.AdEvent.Type.STARTED,
					event =>
					{
						clearTimeout(completeTimeout);
						privateData.adCurrentTime = 0;
						adsManager.setVolume(privateData.adVolume);
						privateData.playing = true;
						let adPosition;
						try
						{
							adPosition = event.getAd().getAdPodInfo().getPodIndex();
						}
						catch(e)
						{
							adPosition = null;
						}
						let adLength;
						try
						{
							adLength = event.getAd().getDuration();
						}
						catch(e)
						{
							adLength = null;
						}
						let adCuePoints = privateData.adCuePoints;

						privateData.playRequest.resolve('started');

						this.dispatchEvent('play');
						this.dispatchEvent('start',{detail:{adPosition,adLength,adCuePoints}});

						privateData.contentPlayer.companionAd.setFromAd(event.getAd());
					}
				);

				adsManager.addEventListener
				(
					google.ima.AdEvent.Type.COMPLETE,
					() =>
					{
						clearTimeout(completeTimeout);
						completeTimeout = setTimeout
						(
							() =>
							{
								console.warn('Discarding completed but non responsive ad break');
								adsManager.discardAdBreak();
							},
							8000
						);
						privateData.playing = false;
						this.dispatchEvent('finish');
						this.dispatchEvent('pause');
						this.adUI.progressBar.progressValue.value = 0;
					}
				);

				adsManager.addEventListener
				(
					google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED,
					() =>
					{
						privateData.active = true;
						this.dispatchEvent('active');
						this.dispatchEvent('playRequest');
						privateData.contentPlayer.companionAd.clear();
					}
				);

				adsManager.addEventListener
				(
					google.ima.AdEvent.Type.IMPRESSION,
					() => this.dispatchEvent('impression')
				);

				adsManager.addEventListener
				(
					google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED,
					() =>
					{
						if(privateData.playRequest)
						{
							privateData.playRequest.reject('ad stack inactivated');
						}

						clearTimeout(completeTimeout);
						if(privateData.playing)
						{
							privateData.playing = false;
							this.dispatchEvent('pause');
						}
						if(privateData.active)
						{
							privateData.active = false;
							this.dispatchEvent('inactive');
						}
						this.adUI.progressBar.progressValue.value = 0;
					}
				);

				adsManager.addEventListener
				(
					google.ima.AdEvent.Type.AD_BREAK_READY,
					() =>
					{
						if(privateData.hasStarted)
						{
							adsManager.start();
						}
					}
				);

				adsManager.addEventListener
				(
					google.ima.AdEvent.Type.PAUSED,
					() =>
					{
						privateData.playing = false;
						this.dispatchEvent('pause');
					}
				);

				adsManager.addEventListener
				(
					google.ima.AdEvent.Type.RESUMED,
					() =>
					{
						let currentTime = privateData.adCurrentTime;
						privateData.playing = true;

						privateData.playRequest.resolve('resumed');

						this.dispatchEvent('play',{detail:{currentTime}});
					}
				);

				[
					google.ima.AdErrorEvent.Type.AD_ERROR,
					google.ima.AdEvent.Type.LOG
				]
				.forEach
				(
					(type,index) =>
					{
						adsManager.addEventListener
						(
							type,
							event =>
							{
								const errors = [];
								let innerError;

								switch(index)
								{
									case 0:
										// fatal error
										innerError = event.getError();
										break;
									case 1:
										// non fatal 'log' error
										innerError = event.getAdData().adError;
										break;
								}

								while(innerError)
								{
									errors.unshift
									(
										{
											code:innerError.getErrorCode && innerError.getErrorCode() || null,
											message:innerError.getMessage && innerError.getMessage() || innerError.message || null,
											raw: innerError
										}
									);
									innerError = innerError.getInnerError && innerError.getInnerError() || null;
								}

								const error = errors[0];
								const errorCode = error.code;
								const errorMessage = error.message;

								// noinspection FallThroughInSwitchStatementJS
								switch(errorCode)
								{
									case google.ima.AdError.ErrorCode.AUTOPLAY_DISALLOWED:
									case google.ima.AdError.ErrorCode.VIDEO_PLAY_ERROR:
									{
										this.dispatchEvent
										(
											'playFailure',
											{
												code:errorCode,
												message:errorMessage,
												innerErrors:errors.slice(1)
											}
										);
										//break;
									}
									default:
									{
										console[['error', 'warn'][index]]('IMA Error: ', errors);
									}
								}

								// noinspection JSIgnoredPromiseFromCall
								// todo: re-enable ima error logging
								// fetch
								// (
								// 	config.errorLog,
								// 	{
								// 		method:'POST',
								// 		body: JSON.stringify
								// 		(
								// 			Object.fromEntries
								// 			(
								// 				Object.entries
								// 				(
								// 					{
								// 						pageKey: config.pageKey,
								// 						pageUrl: config.href,
								// 						playerKey: config.key,
								// 						userAgentID: (config.capabilities.ua||{}).id || null,
								// 						userAgent: (config.capabilities.ua||{}).id ? null : getUserAgent(),
								// 						version: version,
								// 						errors: errors
								// 					}
								// 				)
								// 				.filter( v=>v[1] )
								// 			)
								// 		)
								// 	}
								// )
							}
						);
					}
				);

				const onImaVolumeChange = () =>
				{
					const volume = adsManager.getVolume();
					const targetVolume = privateData.adVolume;

					if(volume !== targetVolume)
					{
						adsManager.setVolume(targetVolume);
					}
				};

				adsManager.addEventListener
				(
					google.ima.AdEvent.Type.VOLUME_CHANGED, onImaVolumeChange
				);

				adsManager.addEventListener
				(
					google.ima.AdEvent.Type.VOLUME_MUTED, onImaVolumeChange
				);

				adsManager.init
				(
					this.element.clientWidth,
					this.element.clientHeight,
					google.ima.ViewMode.NORMAL,
					privateData.contentPlayer.proxy
				);
			}
		);
		loadResult.catch
		(
			() =>
			{
				this.dispatchEvent('loadError');
			}
		);
		return loadResult;
	}

	playing(value)
	{
		const privateData = getPrivateData.for(this);

		if(arguments.length === 0)
		{
			return privateData.playing;
		}

		if(!this.adsManager)
		{
			return Promise.reject('ad is not loaded');
		}

		value = !!value;

		if(value && value === privateData.playing)
		{
			// console.warn('ad controller play request while already playing');
			return value;
		}

		if(value)
		{
			if(privateData.playRequest)
			{
				privateData.playRequest.reject('play was interrupted by another play request');
			}
			privateData.playRequest = {};
			privateData.playRequest.promise = new Promise
			(
				(resolve,reject) =>
				{
					privateData.playRequest.resolve = resolve;
					privateData.playRequest.reject = reject;
				}
			);

			if(privateData.hasStarted)
			{
				this.dispatchEvent('playRequest');
				this.adsManager.resume();
			}
			else
			{
				privateData.hasStarted = true;
				privateData.active = true;
				this.adsManager.start();
			}

			return privateData.playRequest.promise;
		}
		else
		{
			this.adsManager.pause();
		}
	}
}

const getPrivateData = new GetPrivateData(AdPlayer);

AdPlayer.eventList =
[
	'ready','gestured','load','loadError',
	'active','inactive','start','finish',
	'playRequest','play','playFailure','pause',
	'timeupdate','complete','impression'
];



